module.exports = __webpack_public_path__ + "static/media/green-avatar.21004c97.svg";